import { useState, useEffect } from 'react';

const useDarkMode = (defaultValue = false) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    if (saved !== null) {
      return saved === 'true';
    }
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches || defaultValue;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', isDark);

    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  const toggle = () => setIsDark((prev) => !prev);

  return {
    value: isDark,
    toggle,
    set: setIsDark,
  };
};

export default useDarkMode;
